import React from 'react'

const ContextManager = React.createContext();
export default ContextManager
